import {isMobileOnly} from "react-device-detect";

let _extraSmall: boolean | undefined;

/**
 * Returns true when we have to show the mobile layout
 * (we are on a mobile phone or the screen is extremely small).
 *
 * The result is cached to optimize performance
 */
export function extraSmallLayout(): boolean {
    if (_extraSmall === undefined) {
        _extraSmall = window.matchMedia("screen and (max-width:576px)").matches || isMobileOnly;
    }
    return _extraSmall;
}

export function columnLayout(desktopSize: number, desktopOffset: number = 0) {
    if (desktopOffset === 0) {
        return extraSmallLayout() ? {xs: 12, md: desktopSize} : {xs: 12, sm: desktopSize};
    } else {
        return extraSmallLayout() ? {xs: 12, md: {span: desktopSize, offset: desktopOffset}} : {xs: 12, sm: {span: desktopSize, offset: desktopOffset}};
    }
}
